<mat-dialog-content>

    <div class="row x_center logos">
        <div class="col_content y_items_center">
                <img src="assets/images/logo_tywin.png" alt="" title="" class="society" />
        </div>
        <div class="col_content y_items_center"><span>X</span></div>
        <div class="col_content y_items_center">
            <img src="assets/images/logo_mangopay.svg" alt="" title="" class="mangopay" />
        </div>
    </div>

    <div class="ck-content">
        <p class="titre_h3">{{ 'sca.activation.title.value' | translate }}</p>
        <p class="titre_h4" [innerHTML]="description | translate"></p>
        <button class="btn_cta btn_highlight" (click)="redirectToSca()">
            <span>{{ 'sca.activation.action.link' | translate }}</span>
        </button>
        <br/>
        <p [innerHTML]="'sca.activation.help.value' | translate"></p>
    </div>

</mat-dialog-content>

